import React from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Layout } from '../../../components'
import { Start } from './Start'
import { EmailForm } from './EmailForm'
import { EmailVerificationForm } from './EmailVerificationForm'
import { CredentialsForm } from './CredentialsForm'
import { UserStep } from './UserStep'
import { Joining } from './Joining'
import { Initialize } from './Initialize'
import { Finished } from './Finished'
import { Unjoinable } from './Unjoinable'
import { Inexistent } from './Inexistent'
import { FromSSO } from './FromSSO'
import { EmailSent } from './EmailSent'

import { getStep } from './state'
import { Paths } from '../constants'
import { usePathMetadata } from '../../../hooks/usePathMetadata'
import { UrlParams } from './types'
import { useProvideStepAnalytics } from '../../../hooks/useStepAnalytics'
import { JoinSteps } from './JoinSteps'

const STEP_TO_COMPONENT: { [key in JoinSteps]: React.ElementType } = {
  [JoinSteps.Initialize]: Initialize,
  [JoinSteps.Start]: Start,
  [JoinSteps.Email]: EmailForm,
  [JoinSteps.EmailVerification]: EmailVerificationForm,
  [JoinSteps.Password]: CredentialsForm,
  [JoinSteps.CredentialsSubmitted]: UserStep,
  [JoinSteps.Joining]: Joining,
  [JoinSteps.Finished]: Finished,
  [JoinSteps.Unjoinable]: Unjoinable,
  [JoinSteps.Inexistent]: Inexistent,
  [JoinSteps.FromSSO]: FromSSO,
  [JoinSteps.EmailSent]: EmailSent,
}

export function OrganizationJoin({
  superEnabled = false,
}: {
  superEnabled?: boolean
}) {
  const urlParams = useParams<UrlParams>()
  const path = Paths.Join
  const Metadata = usePathMetadata(path)
  const step: JoinSteps = useSelector(getStep)
  const StepComponent = STEP_TO_COMPONENT[step]

  useProvideStepAnalytics(path)

  return (
    <>
      <Metadata />
      <Layout superEnabled={superEnabled}>
        <StepComponent {...urlParams} superEnabled={superEnabled} />
      </Layout>
    </>
  )
}
